export default __webpack_public_path__ + "static/media/hot-water.b14b41ff.svg";